import { Component, computed, inject, input, LOCALE_ID, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { PartiallyPackageReasonFilters } from '../../../../../pages/admin-dashboard/partially-package-reasons/reasons-list/p-p-reason-list.model';
import { FilterInput } from '../../../../../shared/ui/shared-filters/filter-input/filter-input';
import { FilterDateComponent } from '../../../../../shared/ui/shared-filters/filter-date-component/filter-date-component';
import { FilterSortingComponent } from '../../../../../shared/ui/shared-filters/filter-sorting-component/filter-sorting-component';

@Component({
  selector: 'app-p-p-reason-list-filter',
  imports: [FilterInput, FilterDateComponent, FilterSortingComponent],
  templateUrl: './p-p-reason-list-filter.html',
  styleUrl: './p-p-reason-list-filter.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPReasonListFilter {
  private locale = inject(LOCALE_ID);

  filters = input.required<PartiallyPackageReasonFilters>();

  applyFilters = output<PartiallyPackageReasonFilters>();
  toggleSortOrder = output();
  resetFilters = output();

  reasonName = signal<string>('');
  createdOnFrom = signal<string | null>(null);
  createdOnTo = signal<string | null>(null);
  lastModifiedOnFrom = signal<string | null>(null);
  lastModifiedOnTo = signal<string | null>(null);

  createdDateInvalid = signal<boolean>(false);
  lastModifiedDateInvalid = signal<boolean>(false);

  isArabic = computed(() => this.locale.startsWith('ar'));

  sortOptions = computed(() => [
    {
      value: 'CREATION_DATE',
      labelEn: 'Created Date',
      labelAr: 'تاريخ الإنشاء',
    },
    {
      value: 'TITLE',
      labelEn: 'Title',
      labelAr: 'العنوان',
    },
    {
      value: 'LAST_MODIFICATION_DATE',
      labelEn: 'Last Modification',
      labelAr: 'آخر تعديل',
    },
  ]);

  onOrderByChange(value: string) {
    this.filters().orderBy = value as PartiallyPackageReasonFilters['orderBy'];
  }

  onToggleSortOrder() {
    this.toggleSortOrder.emit();
  }

  onResetFilters() {
    this.reasonName.set('');
    this.createdOnFrom.set(null);
    this.createdOnTo.set(null);
    this.lastModifiedOnFrom.set(null);
    this.lastModifiedOnTo.set(null);
    this.createdDateInvalid.set(false);
    this.lastModifiedDateInvalid.set(false);
    this.resetFilters.emit();
  }

  onApplyFilters() {
    const createdInvalid = !!(
      this.createdOnFrom() &&
      this.createdOnTo() &&
      this.createdOnFrom()! > this.createdOnTo()!
    );
    const lastModInvalid = !!(
      this.lastModifiedOnFrom() &&
      this.lastModifiedOnTo() &&
      this.lastModifiedOnFrom()! > this.lastModifiedOnTo()!
    );

    this.createdDateInvalid.set(createdInvalid);
    this.lastModifiedDateInvalid.set(lastModInvalid);

    if (createdInvalid || lastModInvalid) return;

    this.applyFilters.emit({
      reasonName: this.reasonName() || '',
      createdOnFrom: this.createdOnFrom() ?? '',
      createdOnTo: this.createdOnTo() ?? '',
      lastModifiedOnFrom: this.lastModifiedOnFrom() ?? '',
      lastModifiedOnTo: this.lastModifiedOnTo() ?? '',
      orderBy: this.filters().orderBy,
      orderDir: this.filters().orderDir,
    });
  }
}
